import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import {
  create_company_request,
  user_company_domain_list,
  new_company_update_request,
} from "../../user.api";

import BasicDetails from "./manage/form";
import View from "./manage/viewDetails";
import "./style.css";

export default function NewCompanyRequest(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [basicData, setBasicData] = useState({
    mobile_number: props.phone,
  });
  const myRef = useRef(null);
  const [domainData, setDomain] = useState([]);
  const [addCount, setCount] = useState(1);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const getDomainTypes = () => {
    setIsActive(true);
    user_company_domain_list().then((res) => {
      setDomain(res.data);
      setCount(addCount + 1);
      setIsActive(false);
    });
  };
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      let dom = [];
      domainData.forEach((item) => {
        if (item.checked)
          dom.push({ domain_name: item.domain_name, id: item.id });
      });

      setBasicData({ ...data, domain_types: dom });
      setActiveStep(1);
      //
    } else if (id === 2) {
      setdefaultkey(key);
      setActiveStep(0);

      // setBasicData({ ...data });
    } else if (id === 3) {
      // setBasicData({ ...data });
      handleSubmit();
    }
  };
  const handleSubmit = () => {
    setIsActive(true);

    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    const form = new FormData();
    console.log(basicData.product_profiles);
    form.append("company_name", basicData.company_name ?? null);
    form.append("phone_number", basicData.mobile_number);
    form.append("company_type", "kerala");
    form.append("person_name", basicData.person_name ?? null);
    form.append("person_designation", basicData.person_designation ?? null);
    form.append("address", basicData.address ?? null);
    form.append("email", basicData.email ?? null);
    form.append("alternate_email", basicData.alternate_email ?? "");
    form.append("logo", basicData.logo ?? "");

    if (
      basicData.country_code &&
      basicData.country_code !== "" &&
      basicData.alternate_phone &&
      basicData.alternate_phone !== ""
    ) {
      form.append("country_code", basicData.country_code);
    }
    form.append("alternate_phone", basicData.alternate_phone ?? "");
    form.append(
      "abstract_project_proposal",
      basicData.abstract_project_proposal ?? null
    );
    form.append("upload_proposal", basicData.upload_proposal ?? "");
    form.append("registration_certificate", basicData.registration_certificate ?? "");
    // form.append("capital_investment", basicData.capital_investment ?? null);
    form.append("ex_man_power", basicData.ex_man_power ?? null);
    form.append("site_link", basicData.site_link ?? "");
    form.append("company_status", "existing_company");

    // Append financial records as array
    (basicData.financial_records || []).forEach((record, index) => {
      form.append(`financial_records[${index}][financial_year]`, record.financial_year ?? "");
      form.append(`financial_records[${index}][fy_turnover]`, record.fy_turnover ?? "");
      form.append(`financial_records[${index}][remarks]`, record.remarks ?? "");
      form.append(`financial_records[${index}][capital_investment]`, record.capital_investment ?? "");
      form.append(`financial_records[${index}][dir_employ_male]`, record.dir_employ_male ?? "");
      form.append(`financial_records[${index}][dir_employ_female]`, record.dir_employ_female ?? "");
      form.append(`financial_records[${index}][dir_employ_others]`, record.dir_employ_others ?? "");
      form.append(`financial_records[${index}][dir_employ_sc_st]`, record.dir_employ_sc_st ?? "");
      form.append(`financial_records[${index}][dir_employ_pwd]`, record.dir_employ_pwd ?? "");
    });
    form.append("cin_number", basicData?.cin_number ?? "--")
    // form.append("product_profiles", basicData.product_profiles ?? null);

    form.append("achievements", basicData.achievements ?? null);
    if (basicData.fe_component) {
      form.append("fe_component", basicData.fe_component ?? null);
    }
    if (basicData.certification === "Other") {
      form.append("certification", basicData.otherCertification);
    } else {
      form.append("certification", basicData.certification ?? null);
    }


    form.append("any_other_flag", basicData.any_other_flag == true ? "1" : "0");
    form.append(
      "any_other_domain",
      basicData.any_other_flag == true ? basicData.any_other_domain : ""
    );
    form.append("file_name", basicData.file_name ?? "");
    form.append("registration_certificate_name", basicData.registration_certificate_name ?? "");
    if (basicData.id) form.append("application_id", basicData.id);
    basicData.product_profiles.forEach((item, index) => {
      form.append(
        `product_profiles[${index}][product_name]`,
        item.product_name
      );
      form.append(
        `product_profiles[${index}][product_desc]`,
        item.product_desc
      );
    });

    basicData.domain_types.forEach((item, index) => {
      form.append(`domain_types[${index}][domain_name]`, item.domain_name);
      form.append(`domain_types[${index}][id]`, item.id);
    });

    const isUserLoggedIn = props.state?.isUserAuthenticated || false;
    const requestApi = isUserLoggedIn ? new_company_update_request : create_company_request;

    requestApi(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  useEffect(() => {
    if (domainData.length === 0) {
      getDomainTypes();
    }
    // handleChangedata("3");
  }, []);
  const snackbarClose = (flag) => {
    const isError = isSnackError;
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag && !isError) {
      if (props.state?.isUserAuthenticated) {
        props.history.push("/dashboard");
      } else {
        setActiveStep(0);
        setBasicData({});

        setDomain([]);
        props.logout();
      }
    }
  };
  return (
    <div className="page-bg" ref={myRef}>
      <div>
        <Loader open={isActive} />
        <div className="dash-banner ">
          <div className="tit-txt">
            Affiliate an Existing Aerospace Unit in Kerala with KSPACE
          </div>
        </div>
      </div>
      <div className=" my-5 ">
        <div className="container  d-flex justify-content-center">
          {/* <div className="itemc"> */}
          {/* <div className="fomy form-inner-section"> */}
          {activeStep === 0 && (
            <BasicDetails
              {...props}
              data={basicData}
              action={action}
              formData={basicData}
              setDomain={setDomain}
              domainData={domainData}
            />
          )}

          {activeStep === 1 && (
            <View {...props} basicData={basicData} action={action} />
          )}
        </div>
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />
        {/* </div> */}
        {/* </div> */}
      </div>
    </div>
  );
}
